var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.59 0 15.18 0 23 0 C23 2.31 23 4.62 23 7 C22.01 7.66 21.02 8.32 20 9 C20.34444881 11.47266765 20.34444881 11.47266765 21 14 C21.66 14.33 22.32 14.66 23 15 C23 17.64 23 20.28 23 23 C15.41 23 7.82 23 0 23 C0 15.41 0 7.82 0 0 Z M7 5 C7 5.66 7 6.32 7 7 C7.99 7 8.98 7 10 7 C10 6.34 10 5.68 10 5 C9.01 5 8.02 5 7 5 Z M7 10 C7 10.99 7 11.98 7 13 C7.99 13 8.98 13 10 13 C10 12.01 10 11.02 10 10 C9.01 10 8.02 10 7 10 Z M7 16 C7 16.66 7 17.32 7 18 C7.99 18 8.98 18 10 18 C10 17.34 10 16.68 10 16 C9.01 16 8.02 16 7 16 Z ",
    fill: "#FB6334",
    transform: "translate(5,5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTix);
export default __webpack_public_path__ + "static/media/tix.229e2773c27d7719a2ebec2662974bda.svg";
export { ForwardRef as ReactComponent };